@switch (channelType) {
  @case (ChannelType.DEPARTMENT) {
    <ng-container [ngTemplateOutlet]="iconLogo" [ngTemplateOutletContext]="{ iconName: '@tui.folder' }" />
  }
  @case (ChannelType.TELEMONITORING) {
    <ng-container [ngTemplateOutlet]="iconLogo" [ngTemplateOutletContext]="{ iconName: 'telemonitoring' }" />
  }
  @default {
    @let users = channelUsers | chatHideMyself;
    @if (users?.length === 1) {
      <pxc-avatar [attr.data-testid]="'avatar-' + users[0].id" [name]="users[0] | userName" [size]="size" />
    } @else {
      <div
        class="relative"
        [ngClass]="{
          'h-10 w-10': size === Size.SMALL,
          'h-12 w-12': size === Size.MEDIUM,
          'h-16 w-16': size === Size.LARGE,
        }">
        @for (user of users; track user; let idx = $index) {
          @if (idx < 3) {
            <pxc-avatar
              class="absolute"
              [attr.data-testid]="'avatar-' + user.id"
              [name]="user | userName"
              [ngClass]="{
                'left-0 top-0 z-0': idx === 0,
                'left-1 top-1 z-1': idx === 1 && size === Size.SMALL,
                'left-2 top-2 z-2': idx === 2 && size === Size.SMALL,
                'left-1.5 top-1.5 z-1': idx === 1 && size !== Size.SMALL,
                'left-3 top-3 z-2': idx === 2 && size !== Size.SMALL,
              }"
              [size]="size === Size.MEDIUM || size === Size.SMALL ? Size.TINY : Size.SMALL" />
          }
        }
      </div>
    }
  }
}

<ng-template #iconLogo let-iconName="iconName">
  <pxc-avatar class="border border-border-tertiary shadow-xs" [size]="size">
    <tui-icon data-testid="icon" [icon]="iconName" />
  </pxc-avatar>
</ng-template>
